export const flatMap = <T>(data: T[][]): T[] => {
  return data.reduce(
    (prevValue: T[], curValue: T[]) => prevValue.concat(...(curValue ?? [])),
    [] as T[]
  )
}
